module.exports = __webpack_public_path__ + "static/media/pic-ht7.504eb16a.jpg";